import React from 'react';
import ARViewer from './ARViewer';

function App() {
  return (
    <div className="App">
      <ARViewer />
    </div>
  );
}

export default App;
